import { createContext, useEffect, useState, type PropsWithChildren, useContext } from "react";

import { GOOGLE_OAUTH_CLIENT_ID } from "../../config";

interface IGoogleOauthContext {
    googleCredentials?: string;
}

const GoogleOauthContext = createContext({} as IGoogleOauthContext);

export const useGoogleOauth = () => useContext(GoogleOauthContext);

export default function GoogleOauthProvider({ children }: PropsWithChildren<unknown>) {
    const [isReady, setIsReady] = useState(false);
    const [googleCredentials, setGoogleCredentials] = useState<string | undefined>();

    const handleCredentialResponse = (response: any) => {
        setGoogleCredentials(response.credential);
    };

    useEffect(() => {
        const scriptGoogleAccounts = document.createElement("script");
        scriptGoogleAccounts.src = "https://accounts.google.com/gsi/client";
        scriptGoogleAccounts.async = true;
        scriptGoogleAccounts.defer = true;
        document.head.appendChild(scriptGoogleAccounts);

        scriptGoogleAccounts.onload = () => {
            window.google.accounts.id.initialize({
                client_id: GOOGLE_OAUTH_CLIENT_ID,
                callback: handleCredentialResponse,
            });

            setIsReady(true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isReady) {
        return null;
    }

    return (
        <GoogleOauthContext.Provider value={{ googleCredentials }}>
            {children}
        </GoogleOauthContext.Provider>
    );
}
